import { useEffect, useState } from 'react';
import apiClient from 'shared/api/client';
import { API_ROUTES } from 'shared/constants/api';

/**
 * Бейдж окружения (ТЕСТ). Показывается, когда backend.environment != production.
 * Значение — из бэкенда (per-namespace ENV), т.к. фронт собирается одним образом.
 */
export function EnvBadge() {
  const [env, setEnv] = useState<string | null>(null);

  useEffect(() => {
    apiClient
      .get<{ environment: string }>(API_ROUTES.system.config)
      .then((r) => setEnv(r.data?.environment ?? null))
      .catch(() => setEnv(null));
  }, []);

  if (!env || env === 'production') return null;

  const label = env === 'staging' ? 'ТЕСТ' : env.toUpperCase();

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 10,
        right: 10,
        zIndex: 3000,
        background: '#fd7e14',
        color: '#fff',
        padding: '3px 12px',
        borderRadius: 6,
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: 1,
        boxShadow: '0 2px 8px rgba(0,0,0,.25)',
        pointerEvents: 'none',
        userSelect: 'none',
      }}
      title={`Окружение: ${env}`}
    >
      {label}
    </div>
  );
}
